import { useEffect, useMemo, useState } from 'react';
import apiToUrlMap from '../../ApiMapping';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { IOffersSummary, IPooffersItems } from '../../types/IPoOffers';
import { getSelectedItemElectIds } from './Utils';

export const useOffersSummary = (
  items: IPooffersItems[],
  isShipDateFilterOn: boolean,
  matchesSelectedShipWindows: (item: IPooffersItems) => boolean
) => {
  const [summary, setSummary] = useState<IOffersSummary>();
  const { fetchUrl, openSnackBar } = useDataService();

  // a string keeps the fetch off every unrelated change to the offers
  const itemElectIds = useMemo(
    () => getSelectedItemElectIds(items, isShipDateFilterOn, matchesSelectedShipWindows),
    [items, isShipDateFilterOn, matchesSelectedShipWindows]
  );

  useEffect(() => {
    let isCurrent = true;
    const getPOSummary = async () => {
      try {
        const res = await fetchUrl('get', apiToUrlMap.getSummary, {
          params: itemElectIds ? { itemElectIds } : {},
        });
        if (isCurrent) setSummary(res);
      } catch (error: any) {
        openSnackBar('Something went wrong. Try again.', eMessageType.error);
      }
    };
    getPOSummary();

    // a slower earlier response must not land on top of the current selection
    return function () {
      isCurrent = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemElectIds]);

  return summary;
};

export default useOffersSummary;
